// Validated chart palette (light mode) — see the dataviz skill's
// references/palette.md. Categorical hues are used in this fixed order only;
// never cycled (a 9th+ series folds into "Other" instead of repeating a hue).
export const CATEGORICAL_PALETTE = [
  '#2a78d6', // 1 blue
  '#eb6834', // 2 orange
  '#1baf7a', // 3 aqua
  '#eda100', // 4 yellow
  '#e87ba4', // 5 magenta
  '#008300', // 6 green
  '#4a3aa7', // 7 violet
  '#e34948', // 8 red
] as const;

export const OTHER_SLOT_COLOR = '#898781'; // muted ink — for categories folded into "Other"

// Fixed roles — never reused for a generic series.
export const STATUS_COLORS = {
  good: '#0ca30c',
  warning: '#fab219',
  serious: '#ec835a',
  critical: '#d03b3b',
} as const;

/**
 * Assigns each name a categorical color in fixed slot order. Beyond the 8
 * available slots, remaining categories fold into a single "Other" bucket
 * rather than cycling back through the hues (cycling reintroduces a hue
 * collision the fixed order was chosen specifically to avoid).
 */
export function assignCategoricalColors<T extends { name: string; value: number }>(
  entries: T[]
): Array<T & { color: string }> {
  const sorted = [...entries].sort((a, b) => b.value - a.value);
  const capped = sorted.slice(0, CATEGORICAL_PALETTE.length);
  const overflow = sorted.slice(CATEGORICAL_PALETTE.length);

  const result = capped.map((entry, i) => ({ ...entry, color: CATEGORICAL_PALETTE[i] }));

  if (overflow.length > 0) {
    const otherValue = overflow.reduce((sum, e) => sum + e.value, 0);
    result.push({ ...overflow[0], name: 'Other', value: otherValue, color: OTHER_SLOT_COLOR } as unknown as (typeof result)[number]);
  }

  return result;
}
